import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  bannerS:[],
	  common:{},
    video:"",
	  kfShow:false,
    head_nav_index:0,
    contact_us_info:{}
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
